module.exports = __webpack_public_path__ + "img/office-screen-02.c7f0eba3.jpg";